import type { Installment } from '../../../services/installment.service';

/** Local midnight at the start of the day after `now`. */
export function startOfTomorrow(now: Date = new Date()): Date {
  return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
}

/** Earliest NEUTRAL installment whose payment date is before tomorrow (local time), or null. */
export function findInstallmentToPostpone(
  installments: readonly Installment[] | null | undefined,
  now: Date = new Date(),
): Installment | null {
  const cutoff = startOfTomorrow(now).getTime();
  let earliest: { installment: Installment; time: number } | null = null;
  for (const installment of installments ?? []) {
    if (String(installment?.InstallmentState ?? '').trim().toLowerCase() !== 'neutral') continue;
    const time = new Date(String(installment.paymentdate ?? '')).getTime();
    if (!Number.isFinite(time) || time >= cutoff) continue;
    if (!earliest || time < earliest.time) earliest = { installment, time };
  }
  return earliest?.installment ?? null;
}
